const listPointsBody = document.querySelector('#programmsFest').querySelector('#programmsFest-body');
// import auth from '../tools/storage.js';
// import auth from '../tools/storage.js';
import auth from '../tools/storage.js';

export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },

  getElement(item, index, btMoveUp, btMoveDown , programID) {
    let fcID = ` fcid=${item.id} numReq=${item.numRequest} `;
  
    let value = parseInt(item.long, 10);
      // let lhours = parseInt(value/(60*60), 10);
      // let lmins = parseInt(value/(60), 10);
      let lsec = value%(60);
      value -= lsec;
      value = value/60;
      let lmins = value%(60);;
      value -= lmins;
      value = value/60;
      let lhours =value;

      if(lmins < 10)
        lmins = `0${lmins}`;

      if(lsec < 10)
        lsec = `0${lsec}`;

      value = `${lhours}:${lmins}:${lsec}`;
   //small class="colorGray pt-1 mt-1 mr-auto ml-0">${index + 1}/</small>
    return `
            <div class="reference-header  m-0 p-1  local-counter" ${fcID}> 
              <div  class="reference-column m-0 p-0"> 
                <b ${fcID}  class=" p-0 m-0 iconGroupOfConsider w-100">${item.numRequest ? (item.numRequest) : item.id }</b>
              </div>  
              <label ${fcID}  class="reference-column m-0 p-0 pl-1">${item.name}</label>
              <i class="ml-auto mr-1">${value}</i>
              <div class="row m-0 p-0 w-10 pl-3 pr-3">
                ${btMoveUp ? `<button class="ml-0 mr-auto btnMove" name="moveUp" filmID=${item.id} programID=${programID}> > </button>`:''}
                ${btMoveDown ? `<button class="mr-0 ml-auto btnDown" name="moveDown" filmID=${item.id} programID=${programID}> < </button>`:''}
              </div>
            </div>`;
  },

  drawDataInContainer(listWithData) {
    this.cleanContainer();
    let HTMLBODY = '';

    if (listWithData) {
      // console.log(arrcntUserReviewer);

      HTMLBODY = `
          <div class="reference-header firstRow">
              <div class="reference-column">№</div>
              <div class="reference-column">Название работы</div>
          </div>
          `;
      listWithData.forEach((item, index) => {
        HTMLBODY += this.getElement(item, index);
      });
      listPointsBody.innerHTML = HTMLBODY;
    } else
      listPointsBody.innerHTML = ' - - - ';
  },


  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  },

};
